import location from "@/api/location";

export default {
    state: {
    },

    mutations: {
    },

    actions: {
        async retrieveLocationHistories(context, { from, to, userId }) {
            try {
                let params = {
                    location_time_from: from,
                    location_time_to: to,
                };
                if (userId) {
                    params.user_id = userId;
                }
                else {
                    params.account_id = await context.dispatch("showAccountID");
                }

                let res = await location.index(params);
                return res.data.data;
            } catch (error) {
                throw error;
            }
        },
    },

    getters: {
    },
};
